import React, { useState, useEffect } from "react";
import "../styles/Carousel.css";

// Import door images
import embosed from "../assets/112.webp";
import laminate from "../assets/225.webp";
import lominous from "../assets/454.webp";
import metal from "../assets/672.webp";
import ultra from "../assets/783.webp";
import villa from "../assets/889.webp";
import fire from "../assets/908.webp";

const Carousel = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  const doorData = [
    {
      id: 1,
      name: "Luxury Embossed Doors",
      image: embosed, // Basic entry door
    },
    {
      id: 2,
      name: "Luxury Laminate Doors",
      image: laminate, // Interior door
    },
    {
      id: 3,
      name: "Luxury Luminous Doors",
      image: lominous, // Contemporary door
    },
    {
      id: 4,
      name: "Luxury Metal Doors",
      image: metal, // Minimalist door
    },
    {
      id: 5,
      name: "Luxury Ultra Lam Doors",
      image: ultra, // Exterior security door
    },
    {
      id: 6,
      name: "Luxury Villa Doors",
      image: villa, // Villa entrance door
    },
    {
      id: 7,
      name: "Fire Exit Doors",
      image: fire, // Luxury door (ending with premium)
    },
  ];

  // Auto-advance to next door every 4 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setActiveIndex((prevIndex) =>
        prevIndex === doorData.length - 1 ? 0 : prevIndex + 1
      );
    }, 4000);

    return () => clearInterval(interval);
  }, [doorData.length]);

  const getCardPosition = (index) => {
    const totalCards = doorData.length;
    const distance = (index - activeIndex + totalCards) % totalCards;

    if (distance === 0) return "active";
    if (distance === 1) return "adjacent-right";
    if (distance === totalCards - 1) return "adjacent-left";
    if (distance === 2) return "near-right";
    if (distance === totalCards - 2) return "near-left";
    if (distance === 3) return "far-right";
    if (distance === totalCards - 3) return "far-left";
    return "far";
  };

  return (
    <div className="carousel-container">
      <div className="carousel-viewport">
        <div className="carousel-track">
          {doorData.map((door, index) => {
            const position = getCardPosition(index);
            return (
              <div
                key={door.id}
                className={`door-card ${position}`}
                onClick={() => setActiveIndex(index)}
              >
                <div className="card-image">
                  <img src={door.image} alt={`Door ${door.id}`} />
                </div>
                <div className="card-content">
                  <h3 className="door-name">{door.name}</h3>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Carousel;
